module.exports = __webpack_public_path__ + "img/entry3.8ccf35ca.png";